import type { PluginCreator } from 'tailwindcss/types/config'

export const typographyPlugin: PluginCreator = ({ addUtilities }) => {
  addUtilities({
    '.text-inherit': {
      fontSize: 'inherit',
      lineHeight: 'inherit',
      fontWeight: 'inherit'
    },
    '.text-subtitle-1': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: '500'
    },
    '.text-subtitle-2': {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: '500'
    },
    '.text-body-1': {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: '400'
    },
    '.text-body-2': {
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      fontWeight: '400'
    },
    '.text-body-3': {
      fontSize: '0.75rem',
      lineHeight: '1.25rem',
      fontWeight: '400'
    },
    '.text-body-4': {
      fontSize: '0.6875rem',
      lineHeight: '1.25rem',
      fontWeight: '400'
    },
    '.text-body-large': {
      fontSize: '1.125rem',
      lineHeight: '1.75rem',
      fontWeight: '400'
    },
    '.text-hero': {
      fontSize: '3rem',
      lineHeight: '3.75rem',
      fontWeight: '500',

      '@screen md': {
        fontSize: '4.5rem',
        lineHeight: '5.5rem'
      }
    },
    '.text-lead': {
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
      fontWeight: '300',

      '@screen md': {
        fontSize: '1.5rem',
        lineHeight: '2.25rem'
      }
    },
    '.text-h2': {
      fontSize: '1.75rem',
      lineHeight: '2.5rem',
      fontWeight: '500',

      '@screen md': {
        fontSize: '2.5rem',
        lineHeight: '3.5rem'
      }
    },
    '.text-h3': {
      fontSize: '1.5rem',
      lineHeight: '2.25rem',
      fontWeight: '500',

      '@screen md': {
        fontSize: '1.75rem',
        lineHeight: '2.5rem'
      }
    },
    '.text-h5': {
      fontSize: '1.125rem',
      lineHeight: '1.75rem',
      fontWeight: '500',

      '@screen md': {
        fontSize: '1.25rem',
        lineHeight: '2rem',
        fontWeight: '500'
      }
    }
  })
}
